// extracted by mini-css-extract-plugin
export default {"cls1":"ResearcherList-cls1_FMM","cls2":"ResearcherList-cls2_ViZ ResearcherList-cls1_FMM"};